<template>
  <div>
    <h1>Event Report</h1>

    <div class="row mb-3">
      <div class="col-sm">

        <form ref="form" @submit.prevent="fetchEvents">
          <b-row>
            <b-col cols="6">
              <b-form-group class="mb-0">
                <b-row>
                  <b-col cols="6">
                    <label for="start-date-input">Start Date
                      <b-form-datepicker id="start-date-input"
                                         v-model="selected.startDate"
                                         label="Start Date"
                      />
                    </label>
                  </b-col>
                  <b-col cols="6">
                    <label for="start-time-input" v-if="selected.startDate != null">Start Time
                      <b-form-timepicker id="start-time-input"
                                         v-if="selected.startDate != null"
                                         v-model="selected.startTime"
                                         label="Start Time"
                      />
                    </label>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <label for="end-date-input">End Date
                      <b-form-datepicker id="end-date-input"
                                         v-model="selected.endDate"
                                         label="End Date" inline
                      />
                    </label>
                  </b-col>
                  <b-col cols="6">
                    <label for="end-time-input" v-if="selected.endDate != null">End Time
                      <b-form-timepicker id="end-time-input"
                                         v-if="selected.endDate != null"
                                         v-model="selected.endTime"
                                         label="End Time" inline
                      />
                    </label>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <label for="checkbox-group">
                Event Type
                <b-form-checkbox-group
                        id="checkbox-group"
                        v-model="selected.type"
                        :options="types"
                        label=""
                ></b-form-checkbox-group>
              </label>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-button type="submit" variant="primary" class="col-1 mt-2">Search</b-button>
              <b-button type="button" variant="secondary" class="col-1 mt-2 ml-3" @click="clear">Clear</b-button>
            </b-col>
          </b-row>
        </form>

      </div>
    </div>

    <div class="row" v-if="isSearching">
      <div class="col-sm">
        <b-table hover small responsive show-empty
                 :fields="fields"
                 :items="eventList"
                 :busy="isLoading">

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>

          <template v-slot:empty="scope">
            <p>No events found.</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>
        </b-table>
      </div>
    </div>

  </div>
</template>

<script>
  import config from '@/config'
  import axios from 'axios';
  import axiosRetry from 'axios-retry';

  axiosRetry(axios, { retries: 3 });

  export default {
    data: () => ({
      isLoading: false,
      isSearching: false,

      fields: [
        {key: 'eventDate', sortable: true, label: 'Date'},
        {key: 'operation', sortable: true, label: 'Operation'},
        {key: 'fileName', sortable: true, label: 'File Name'},
        {key: 'bucketName', sortable: true, label: 'Bucket Name'},
        {key: 'username', sortable: true, label: 'Username'},
      ],
      eventList: [],
      selected: {
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        type: []
      },
      types: [
        { text: 'Upload', value: 'upload' },
        { text: 'Download', value: 'download' },
        { text: 'Delete', value: 'delete' },
      ]
    }),

    created () {
      this.initialize()
    },

    computed: {
      formTitle () {
        return 'Event Report'
      }
    },



    methods: {
      clear() {
        this.selected.type = []
        this.selected.startTime = null
        this.selected.startDate = null
        this.selected.endTime = null
        this.selected.endDate = null
      },
      fetchEvents() {
        let payload = {
          startDate: this.selected.startDate != null ? this.selected.startDate + "T" + (this.selected.startTime != null ?  this.selected.startTime : '00:00:00') : null,
          endDate: this.selected.endDate != null ? this.selected.endDate + "T" + (this.selected.endTime != null ? this.selected.endTime : '00:00:00') : null,
          eventType: this.selected.type
        }
        axios.post(`${config.CLOUDDRIVE_API_ENDPOINT}eventReport`, payload)
                .then(response => {
                  this.eventList = response.data
                  this.isLoading = false
                  this.isSearching = true
                })
      },

      initialize() {
        this.isLoading = true
      },

    }
  }
</script>